/* eslint-disable @typescript-eslint/no-explicit-any */
export type PlainObject = Record<string, any>;

export const isPlainObject = (value: unknown): value is PlainObject =>
  !!value && typeof value === 'object' && !Array.isArray(value);

export const isRichTextDocument = (value: PlainObject): boolean =>
  value.type === 'doc' && Array.isArray(value.children);

type ObjectVisitor = (object: PlainObject) => 'skipChildren' | void;

export const visitObjects = (data: unknown, visit: ObjectVisitor): void => {
  const visited = new WeakSet<object>();

  const walk = (node: unknown): void => {
    if (!node || typeof node !== 'object' || visited.has(node)) return;

    visited.add(node);

    if (Array.isArray(node)) {
      node.forEach(walk);

      return;
    }

    if (visit(node as PlainObject) === 'skipChildren') return;

    Object.values(node).forEach(walk);
  };

  walk(data);
};
